import { cx } from "@jugl-web/utils";
import { FC, ReactNode } from "react";
import { ChatDrawer } from "../../ChatDrawer";
import { useLiveChatUIContext } from "../LiveChatUIContext";

export interface LiveChatUISidebarProps {
  children: ReactNode;
  className?: string;
}

export const LiveChatUISidebar: FC<LiveChatUISidebarProps> = ({
  children,
  className,
}) => {
  const { isSidebarOpen, closeSidebar } = useLiveChatUIContext();

  const panelContent = (
    <div
      className={cx("flex h-full flex-col overflow-hidden bg-white", className)}
    >
      <div className="jugl__custom-scrollbar flex flex-1 flex-col overflow-y-auto overflow-x-hidden px-3 py-4">
        {children}
      </div>
    </div>
  );

  return (
    <>
      {/* Desktop / Tablet: always-visible sidebar panel */}
      <aside
        className={cx(
          "border-dark-100 hidden shrink-0 flex-col overflow-hidden border-b-0 border-l-0 border-r border-t-0 border-solid md:flex",
          "w-[240px]"
        )}
      >
        {panelContent}
      </aside>

      {/* Mobile: slide-over drawer */}
      <ChatDrawer
        isOpen={isSidebarOpen}
        placement="left"
        positionStrategy="fixed"
        panelClassName="w-full max-w-[300px]"
        onClose={closeSidebar}
      >
        {panelContent}
      </ChatDrawer>
    </>
  );
};
